import { render, staticRenderFns } from "./ChatECardGroupAuthor.vue?vue&type=template&id=589cb18c&scoped=true"
import script from "./ChatECardGroupAuthor.vue?vue&type=script&lang=js"
export * from "./ChatECardGroupAuthor.vue?vue&type=script&lang=js"
import style0 from "./ChatECardGroupAuthor.vue?vue&type=style&index=0&id=589cb18c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589cb18c",
  null
  
)

export default component.exports